import React from 'react'

import {
  Box,
  Icon,
  Section,
  Spinner,
  Text,
  Tooltip,
  useToggle,
} from '@factorialco/deprecated-design-system'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { useAttendanceSettingWorkCategories } from 'modules/attendance/lib/attendanceSettingWorkCategoriesContext'
import ExtraHoursRangeUtils from 'modules/attendance/lib/utils/ExtraHoursRangeUtils'

import ExtraHoursRulesWizard from '../ExtraHoursRulesWizard'
import TimeSettingsCallout from '../TimeSettingsCallout'
import BaseRule from './BaseRule'
import CustomRule from './CustomRule'

const ExtraHoursRules = () => {
  const [openBaseInfo, toggleOpenBaseInfo] = useToggle()
  const [openCustomInfo, toggleOpenCustomInfo] = useToggle()
  const [newExtraHourRuleModal, setNewExtraHourRuleModal] = React.useState(false)
  const { extraHoursRanges, loading, attendanceSetting } = useAttendanceSettingWorkCategories()
  const customExtraHoursRanges = ExtraHoursRangeUtils.sortedCustomByFromMinute(extraHoursRanges)
  const defaulExtraHoursRange = ExtraHoursRangeUtils.defaultExtraHoursRanges(extraHoursRanges)

  const latestToMinute = customExtraHoursRanges.at(-1)?.toMinute
  const fromHourRange = latestToMinute ? latestToMinute / 60 + 1 : 1

  if (loading)
    return (
      <Box justifyContent="center" alignItems="center" height="full">
        <Spinner />
      </Box>
    )

  return (
    <Section
      illustration="holidays-event-tenure"
      title={i18n.t('time_tracking.settings.work_time_categories.extra_hours_rules.title')}
      description={i18n.t(
        'time_tracking.settings.work_time_categories.extra_hours_rules.description'
      )}
      action={{
        onClick: () => {
          setNewExtraHourRuleModal(true)
          track(trackingEvents.timeTracking.newExtraHourRulePressed)
        },
        label: i18n.t(
          'time_tracking.settings.work_time_categories.extra_hours_rules.new_extra_hour_rules'
        ),
      }}
    >
      <Box gap="s24">
        <Box gap="s12">
          <Box flexDirection="row">
            <Text color="grey1000" size="300" weight="semibold">
              {i18n.t(
                'time_tracking.settings.work_time_categories.extra_hours_rules.base_rule.title'
              )}
            </Text>
            <Tooltip.Alt
              attachment="bottom center"
              targetAttachment="top center"
              open={openBaseInfo}
              toggle={toggleOpenBaseInfo}
              label={i18n.t(
                'time_tracking.settings.work_time_categories.extra_hours_rules.base_rule.tooltip'
              )}
            >
              <Icon.Medium icon="question-circle-line" color="grey800" />
            </Tooltip.Alt>
          </Box>
          {defaulExtraHoursRange && <BaseRule extraHourRule={defaulExtraHoursRange} />}
        </Box>
        {ExtraHoursRangeUtils.hasCustomExtraHoursRanges(extraHoursRanges) && (
          <Box gap="s8">
            <Box flexDirection="row">
              <Text color="grey1000" size="300" weight="semibold">
                {i18n.t(
                  'time_tracking.settings.work_time_categories.extra_hours_rules.custom_rule.title'
                )}
              </Text>
              <Tooltip.Alt
                attachment="bottom center"
                targetAttachment="top center"
                open={openCustomInfo}
                toggle={toggleOpenCustomInfo}
                label={i18n.t(
                  'time_tracking.settings.work_time_categories.extra_hours_rules.custom_rule.tooltip'
                )}
              >
                <Icon.Medium icon="question-circle-line" color="grey800" />
              </Tooltip.Alt>
            </Box>
            {customExtraHoursRanges.map((extraHourRule) => (
              <CustomRule key={extraHourRule.id} extraHourRule={extraHourRule} />
            ))}
          </Box>
        )}
      </Box>
      <Box paddingTop="s16">
        {ExtraHoursRangeUtils.hasTimeOffRanges(extraHoursRanges) && (
          <TimeSettingsCallout attendanceSetting={attendanceSetting} />
        )}
      </Box>
      {newExtraHourRuleModal && (
        <ExtraHoursRulesWizard
          onClose={() => setNewExtraHourRuleModal(false)}
          fromHourRange={fromHourRange}
        />
      )}
    </Section>
  )
}

export default ExtraHoursRules
